import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  icon: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
}));
